/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  async getCacheKeys() {
    const response = await axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/cache_keys`
    );
    return response.data.cache_keys;
  }

  async fetchContactPilotSsoLink() {
    const response = await axios.post(
      `/api/v1/accounts/${this.accountIdFromRoute}/contact_pilot_sso_link`
    );
    return response.data.url;
  }
}

export default new AccountAPI();
